// CB:BEGIN about-corebids-page
import React from 'react';
import SharedHeaderHomeowner from './SharedHeaderHomeowner';

interface AboutCoreBidsProps {
  onNavigate: (screen: string) => void;
}

const AboutCoreBids: React.FC<AboutCoreBidsProps> = ({ onNavigate }) => {
  return (
    <div className="container">
      <SharedHeaderHomeowner onNavigate={onNavigate} />
      <div className="content" style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', fontSize: '36px', fontWeight: '700', color: '#1f2937' }}>
          About CoreBids
        </h1>
        
        <div style={{ 
          background: '#ffffff', 
          padding: '40px', 
          borderRadius: '12px', 
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          lineHeight: '1.6',
          color: '#374151'
        }}>
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            CoreBids makes it easy to get roofing and exterior work done—without the stress.
          </p>
          
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            We connect homeowners nationwide with trusted, vetted local contractors who are ready to compete for your project. Instead of chasing estimates or dealing with sales pressure, CoreBids brings real bids to you—clearly, transparently, and on your terms.
          </p>
          
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            Using remote measurements and standardized project details, we help ensure bids are accurate and comparable. Homeowners can review options, communicate directly with contractors, and move forward with confidence knowing pricing, scope, and expectations are clear from the start.
          </p>
          
          <p style={{ marginBottom: '32px', fontSize: '16px' }}>
            Whether it's storm damage or a planned upgrade, CoreBids helps you find the right professional faster—so you can get back to what matters.
          </p>
          
          <ul style={{ 
            listStyle: 'none', 
            padding: 0, 
            margin: '0 0 32px 0',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            {[
              'Trusted local professionals',
              'Competitive bids — no pressure',
              'Clear scope and pricing',
              'Secure payments & financing options',
              'No obligation to hire'
            ].map((item, idx) => (
              <li key={idx} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                fontSize: '16px',
                color: '#374151'
              }}>
                <span style={{
                  color: '#123c3b',
                  fontWeight: 700,
                  marginTop: '2px',
                  flexShrink: 0
                }}>✔</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          
          <div style={{ textAlign: 'center', marginTop: '32px' }}>
            <button 
              onClick={() => onNavigate('landing')}
              style={{
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: 600,
                color: '#ffffff',
                backgroundColor: '#123c3b',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#0d2928';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#123c3b';
              }}
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCoreBids;
// CB:END about-corebids-page
